/**
 * "Color by": the attribute the section's grid cells are colored by. The
 * legend follows the choice -- its title is the chosen attribute's label.
 */
import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { useAtom } from 'jotai';
import { primaryKeyForSection } from '../../Post/PostLayer';
import { attributeOptionsFor } from '../attributeOptions';
import { PanelField, panelSelectSx } from './panelFields';

const COLOR_BY_HINT =
  'The attribute that colors the grid cells. A plain attribute ranks each cell against the ' +
  'other cells of its own event, so every event spans the legend; the legend shows the scale ' +
  'for the chosen attribute.';

export const ColorByControl: React.FC<{ sectionId: string }> = ({ sectionId }) => {
  const options = attributeOptionsFor(sectionId);
  const [primaryKey, setPrimaryKey] = useAtom(primaryKeyForSection(sectionId));

  if (options == null) {
    return null;
  }

  // A key the section does not offer (the atom's default is shared across
  // sections) shows as no selection rather than as an out-of-range value.
  const value = options.primary.some(option => option.key === primaryKey) ? primaryKey : '';

  return (
    <PanelField id="color-by-label" label="Color by" hint={COLOR_BY_HINT}>
      <Select
        fullWidth
        size="small"
        labelId="color-by-label"
        value={value}
        onChange={event => setPrimaryKey(event.target.value)}
        sx={panelSelectSx}
      >
        {options.primary.map(option => (
          <MenuItem key={option.key} dense value={option.key}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </PanelField>
  );
};
